import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getReactSelectThemeProps } from "../../../helpers/reactSelectThemeStyles";
import "./CustomSelect.scss";

const reactSelectThemeProps = getReactSelectThemeProps();

const CustomSelect = ({
  options,
  name,
  initValue,
  label,
  placeholder,
  disabled,
  onChange,
  className = "",
}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleSelectChange = (option) => {
    setSelectedOption(option);
    onChange(name, option);
  };

  useEffect(() => {
    if (initValue && initValue.value) {
      setSelectedOption(initValue);
    }
  }, [initValue]);

  return (
    <div className={`custom-select-wrapper ${className}`.trim()}>
      {label ? <label className="custom-select-label">{label}</label> : null}
      <Select
        {...reactSelectThemeProps}
        options={options}
        value={selectedOption}
        isDisabled={disabled}
        placeholder={placeholder}
        onChange={handleSelectChange}
      />
    </div>
  );
};

export default CustomSelect;
